import routeHelper from 'components/shared/mixins/routeHelper'

export default {
    mixins: [routeHelper],
    computed: {
        getSubmitButtonStyles () {
            return {
                'submit': {
                    'container': {
                        'default': {
                            'backgroundColor': '#e47700',
                            'border-radius': '20px',
                            'padding': '2px',
                            'margin': '0px 10px 5px 0px'
                        },
                        'hover': {
                            'backgroundColor': '#0bab69',
                            'margin-right': '10px'
                        },
                        'click': {
                            'backgroundColor': '#068e56',
                            'margin-right': '10px'
                        }
                    },
                    'svg': {
                        'content': '<?xml version="1.0" ?> <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"> <g> <path d="M21.66,12a2,2,0,0,1-1.14,1.81L5.87,20.75A2.08,2.08,0,0,1,5,21a2,2,0,0,1-1.82-2.82L5.46,13H11a1,1,0,0,0,0-2H5.46L3.18,5.87A2,2,0,0,1,5.86,3.25h0l14.65,6.94A2,2,0,0,1,21.66,12Z"> </path> </g> </svg>',
                        'styles': {
                            'default': {
                                'width': '1.3em',
                                'marginTop': '0.15em',
                                'filter': 'brightness(0) saturate(100%) invert(100%) sepia(28%) saturate(2%) hue-rotate(69deg) brightness(107%) contrast(100%)'
                            }
                        }
                    }
                },
                'loading': {
                    'container': {
                        'default': {
                            'backgroundColor': 'white'
                        }
                    },
                    'svg': {
                        'styles': {
                            'default': {
                                'filter': 'brightness(0) saturate(100%) invert(72%) sepia(0%) saturate(3044%) hue-rotate(322deg) brightness(100%) contrast(96%)'
                            }
                        }
                    }
                },
                'stop': {
                    'container': {
                        'default': {
                            'backgroundColor': 'white'
                        },
                        'hover': {
                            'backgroundColor': '#dadada52'
                        }
                    },
                    'svg': {
                        'content': '<?xml version="1.0" encoding="utf-8"?> <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"> <rect width="24" height="24" rx="4" ry="4" /> </svg>',
                        'styles': {
                            'default': {
                                'width': '0.95em',
                                'marginTop': '0.32em',
                                'filter': 'brightness(0) saturate(100%) invert(72%) sepia(0%) saturate(3044%) hue-rotate(322deg) brightness(100%) contrast(96%)' }
                        }
                    }
                }
            }
        },
        getMessageStyles () {
            if (this.isMobileView) {
                return {
                    'default': {
                        'shared': {
                            'bubble': {
                                'font-family': 'Nunito-Regular, sans-serif',
                                'margin-top': '5px',
                            },
                            'innerContainer': {
                                'flex-direction': 'column'
                            }
                        },
                        'user': {
                            'bubble': {
                                'padding': '15px 15px 15px 15px',
                                'maxWidth': '100%',
                                'backgroundColor': '#eeeeee',
                                'fontSize': '1.2rem',
                                'color': 'black',
                                'border-radius': '10px 0px 10px 10px'
                            }
                        },
                        'ai': {
                            'bubble': {
                                'padding': '15px 15px 10px 15px',
                                'maxWidth': '100%',
                                'backgroundColor': '#FAE4CC',
                                'fontSize': '1.2rem',
                                'border-radius': '0px 10px 10px 10px'
                            }
                        },
                        'suggestion': {
                            'bubble': {
                                'padding': '15px 15px 10px 15px',
                                'maxWidth': '100%',
                                'backgroundColor': '#FAE4CC',
                                'fontSize': '1.2rem',
                                'border-radius': '0px 10px 10px 10px',
                                'margin-left': 'auto',
                                'margin-right': 'auto',
                                'width': 'calc(97.5% - 24px)',
                                'max-width': '100%',
                            }
                        }
                    },
                    'loading': {
                        'bubble': {
                            'width': 'max-content !important',
                            'padding': '15px 15px 15px 20px',
                            'maxWidth': '100%',
                            'backgroundColor': '#FAE4CC',
                            'fontSize': '1.2rem',
                            'border-radius': '0px 10px 10px 10px'
                        }
                    },
                    'error': {
                        'bubble': {
                            'padding': '15px 15px 15px 20px',
                            'maxWidth': '100%',
                            'fontSize': '1.2rem'
                        }
                    }
                }
            } else {
                return {
                    'default': {
                        'shared': {
                            'bubble': {
                                'font-family': 'Nunito-Regular, sans-serif',
                                'margin-top': '5px',
                            },
                            'innerContainer': {
                                'flex-direction': 'column'
                            }
                        },
                        'user': {
                            'bubble': {
                                'padding': '15px 15px 15px 15px',
                                'maxWidth': '100%',
                                'backgroundColor': '#eeeeee',
                                'fontSize': '1.4rem',
                                'color': 'black',
                                'border-radius': '10px 0px 10px 10px'
                            }
                        },
                        'ai': {
                            'bubble': {
                                'padding': '15px 15px 10px 15px',
                                'maxWidth': '100%',
                                'backgroundColor': '#FAE4CC',
                                'fontSize': '1.4rem',
                                'border-radius': '0px 10px 10px 10px'
                            }
                        },
                        'suggestion': {
                            'bubble': {
                                'padding': '15px 15px 10px 15px',
                                'maxWidth': '100%',
                                'backgroundColor': '#FAE4CC',
                                'fontSize': '1.4rem',
                                'border-radius': '0px 10px 10px 10px',
                                'margin-left': 'auto',
                                'margin-right': 'auto',
                                'width': 'calc(97.5% - 24px)',
                                'max-width': '100%',
                            }
                        }
                    },
                    'loading': {
                        'bubble': {
                            'width': 'max-content !important',
                            'padding': '15px 15px 15px 20px',
                            'maxWidth': '100%',
                            'backgroundColor': '#FAE4CC',
                            'fontSize': '1.4rem',
                            'border-radius': '0px 10px 10px 10px'
                        }
                    },
                    'error': {
                        'bubble': {
                            'color': 'black',
                            'backgroundColor': 'rgb(244, 192, 192)',
                            'borderRadius': '10px',
                            'margin-top': '15px',
                            'padding': '15px 15px 15px 20px',
                            'maxWidth': '100%',
                            'fontSize': '1.4rem'
                        }
                    }
                }
            }
        },
        getInputAreaStyles () {
            return {
                'fontSize': '1.4rem',
                'background': '#f8f8f8f8'
            }
        },
        getNameSettings () {
            return {
                'default': {
                    'style': {
                        'fontSize': '1.1rem',
                        'color': '#888888'
                    }
                },
                'ai': {
                    'text': 'EVA:',
                    'position': 'left'
                },
                'suggestion': {
                    'text': 'EVA:',
                    'position': 'left'
                },
                'user': {
                    'text': 'You:',
                    'position': 'left',
                    'style': {
                        'display': 'flex',
                        'justify-content': 'flex-end',
                        'margin-right': '0px'
                    }
                },
                'error': {
                    'style': {
                        'display': 'none',
                    }
                }
            }
        },
        getTextInputSettings () {
            return {
                'styles': {
                    'container': {
                        'borderRadius': '20px',
                        'border': 'solid 1px #DDDDDD',
                        'width': '90%',
                        'boxShadow': 'unset',
                        'fontSize': '16px'
                    },
                    'text': {
                        'padding': '10px',
                        'paddingLeft': '15px',
                        'paddingRight': '34px'
                    }
                },
                'placeholder': {
                    'text': this.$t('Chatbot.inputbox_placeholder_label'),
                    'style': {
                        'color': '#AAAAAA'
                    }
                }
            }
        },
        getHtmlClassUtilities () {
            return {
                'course-link': {
                    styles: {
                        default: {
                            borderRadius: '20px',
                            padding: '4px 13px',
                            color: '#000000',
                            backgroundColor: '#ffffff',
                            textDecoration: 'none',
                            border: 'solid 1px #C65300',
                            display: 'inline-flex',
                            fontFamily: 'Nunito-Regular, sans-serif',
                            cursor: 'pointer',
                            alignItems: 'center',
                            margin: '5px 0'
                        }
                    },
                    events: { click: (event) => this.handleCourseLinkClick(event) },
                },
                'learningpath-link': {
                    styles: {
                        default: {
                            borderRadius: '20px',
                            padding: '4px 13px',
                            color: '#000000',
                            backgroundColor: '#ffffff',
                            textDecoration: 'none',
                            border: 'solid 1px #C65300',
                            display: 'inline-flex',
                            fontFamily: 'Nunito-Regular, sans-serif',
                            cursor: 'pointer',
                            alignItems: 'center',
                            margin: '5px 0'
                        }
                    },
                    events: { click: (event) => this.handleLearningPathLinkClick(event) },
                },
                'course-link-text': {
                    styles: {
                        default: {
                            lineHeight: '19px'
                        }
                    }
                },
                'course-link-icon': {
                    styles: {
                        default: {
                            margin: '0px 5px 0px 0px',
                            height: '17px'
                        }
                    }
                },
                'suggestion-icon-link': {
                    styles: {
                        default: {
                            margin: '3px 0px 3px 10px',
                            height: '14px',
                            fontSize: '1rem'
                        }
                    }
                },
                'feedback-container-history': {
                    styles: {
                        default: {
                            justifyContent: 'flex-end',
                            gap: '7px',
                            display: 'flex'
                        }
                    }
                },
                'message': {
                    styles: {
                        default: {
                            whiteSpace: 'pre-line',
                            height: 'inherit',
                            display: 'flex'
                        }
                    }
                },
                'suggestion-buttons': {
                    styles: {
                        default: {
                            justifyContent: 'center'
                        }
                    }
                },
                'feedback-icon': {
                    styles: {
                        default: {
                            'margin': '10px 0 0',
                            'transition': 'opacity 0.3s',
                            'opacity': '1',
                            'padding': '8px 12px',
                            'backgroundColor': '#F4C999',
                            'border-radius': '5px'
                        },
                        hover: {
                            'cursor': 'pointer',
                            'backgroundColor': '#efad66'
                        }
                    },
                    events: { click: (event) => this.handleFeedbackClick(event) }
                },
                'feedback-text': {
                    styles: {
                        default: {
                            'display': 'flex',
                            'margin': '17px 0px 0px',
                            'align-items': 'center'
                        }
                    }
                },
                'feedback-icon-sent-history': {
                    styles: {
                        default: {
                            'background': '#EFAD66',
                            'margin': '10px 0px 0px',
                            'padding': '8px 12px',
                            'border-radius': '5px'
                        }
                    }
                },
                'error-message': {
                    styles: {
                        default: {
                            'padding': '10px',
                            'borderRadius': '10px',
                            'display': 'flex',
                        }
                    }
                },
                'deep-chat-suggestion-button': {
                    styles: {
                        default: {
                            'color': '#000000',
                            'border': '1px solid grey',
                            'cursor': 'pointer',
                            'fontFamily': 'Nunito-Regular, sans-serif',
                            'fontSize': '1.2rem',
                            'display': 'flex',
                            'alignItems': 'center',
                            'justifyContent': 'center',
                            'margin': '5px 0',
                            'text-align': 'left'
                        },
                        hover: {
                            'backgroundColor': '#efad66'
                        }
                    }
                }
            }
        },
        getGeneralStyles () {
            if (this.isMobileView) {
                return `border: 0; width: ${window.innerWidth}px; height: ${window.innerHeight - 110}px; background-color: #f8f8f8; opacity: 1;`
            } else {
                return 'border: 0; width: 540px; height: calc(100vh - 270px); background-color: #f8f8f8; opacity: 1;'
            }
        }
    },
    methods: {
        async handleCourseLinkClick (event) {
            const course = await this.$store.dispatch('Courses/loadCourseWithId', event.target.id)
            this.$router.push(this.getRouteToCourse(course))
            if (this.isMobileView) {
                this.closeChatbot()
            }
        },
        async handleLearningPathLinkClick (event) {
            const learningPath = await this.$store.dispatch('LearningPaths/getSingleLearningPathWithId', event.target.id)
            this.$router.push(this.getRouteToLearningPath(learningPath.slug))
            if (this.isMobileView) {
                this.closeChatbot()
            }
        }
    }
}
